import { useReplayContext } from "~/app";
import { Spacing } from "~/jsx/theme";
import {
  Command,
  XUpdatableInput,
  clamp,
  isLocalhost,
  undoApiFactory,
} from "~/utils";
import { XButton, XTypography } from "../design";
import { GameApi } from "~/business";
import { gameSerializer } from "~/infra";

export const XEventNavigator = () => {
  const { commandIndex, setCommandIndex, commands, history } =
    useReplayContext();

  const minIndex = 0;
  const maxIndex = commands.length;

  const setIndexLocal = (index: number) => {
    index = clamp(index, minIndex, maxIndex);
    if (index === commandIndex) return;
    return () => setCommandIndex(index);
  };

  const onReplay = () => {
    const { steps } = history;
    const currentStep = steps.at(commandIndex - 1);
    const gameBeforeCommand = steps.at(commandIndex - 2)?.state;
    if (!currentStep || !gameBeforeCommand) return;
    const { command } = currentStep;
    return () => {
      console.info("game before", gameBeforeCommand);
      console.info("replaying", command);
      const gameCopy = gameSerializer().copy(gameBeforeCommand.gameState);
      const gameApi = GameApi(gameCopy, command.playerId);
      const undoApi = undoApiFactory(
        gameBeforeCommand.undoState,
        command.playerId
      );
      if (Command.isCommand(command, gameApi)) {
        Command.call(gameApi, command);
      } else if (Command.isCommand(command, undoApi)) {
        Command.call(undoApi, command);
      }
      console.info("game after", gameCopy);
    };
  };

  return (
    <div style={{ display: "flex", gap: Spacing.px8, alignItems: "center" }}>
      <XButton onClick={setIndexLocal(minIndex)}>{"|<<"}</XButton>
      <XButton onClick={setIndexLocal(commandIndex - 1)}>{"<"}</XButton>
      <XTypography>
        <XUpdatableInput
          value={commandIndex.toString()}
          style={{ display: "inline-block" }}
          onChange={(value) => setIndexLocal(parseInt(value, 10))?.()}
        />
        /{commands.length}
      </XTypography>
      <XButton onClick={setIndexLocal(commandIndex + 1)}>{">"}</XButton>
      <XButton onClick={setIndexLocal(maxIndex)}>{">>|"}</XButton>
      {isLocalhost() && <XButton onClick={onReplay()}>Replay command</XButton>}
    </div>
  );
};
